import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { MsalDynamicProvider } from "./providers/MsalDynamicProvider";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { create } from "zustand";
import { persistStore } from "../zustand/persistStore";
import { AxiosProvider } from "./providers/AxiosProvider";

// Logger
import { logger } from "react-native-logs";
import { loggerConfig } from "./loggerConfig";

// i18n
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

/* global document, Office, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

export const useStore = create(persistStore);

export const log = logger.createLogger(loggerConfig);

/* Render application after Office initializes */
Office.onReady((info) => {
  if (info.host === Office.HostType.Excel) {
    // Reset isRefreshInProgress to false when sheet initializes
    // This ensures the refresh button is available when the add-in loads
    useStore.setState({ isRefreshInProgress: false });

    root?.render(
      <I18nextProvider i18n={i18n}>
        <FluentProvider theme={webLightTheme}>
          <MsalDynamicProvider>
            <AxiosProvider>
              <App />
            </AxiosProvider>
          </MsalDynamicProvider>
        </FluentProvider>
      </I18nextProvider>
    );
  }
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
